import React from 'react';
import { cn } from '@/lib/utils';
import HighlightText from '@/app/features/reports/components/test-tile/highlight-text';
import { ImageRow } from '@/app/features/reports/v2/ImageGrid';
import TextWithBreaks from '@/components/raytd/convert-line-break';
import { TestSuite } from 'store/src/lib/tests/entity';
import { ReportTestItem } from '../../utils/entities';
import CustomFieldContainer from './custom-fields';
import TextTile from './text-with-label';
import Result from './result';

interface ExpandableContentProps {
    item: ReportTestItem;
    testSuite: TestSuite;
    isExpanded: boolean;
    className?: string;
    /**
     * SDA's compact row already carries Observations/Recommendations as dedicated columns —
     * custom fields aren't part of that table design. A testSuite that still has legacy
     * custom_fields configured (unrelated to whether the report is SDA-Format) was injecting an
     * extra px-4/py-2 block only for SOME SDA tiles, producing inconsistent trailing space above
     * the next tile's grey separator (raytd/web QA 108.02, item 4).
     */
    isSdaFormat?: boolean;
}

const ExpandableContent: React.FC<ExpandableContentProps> = ({
    item,
    testSuite,
    isExpanded,
    className,
    isSdaFormat = false,
}) => {
    if (!isExpanded) return null;

    const hasCustomFields = !isSdaFormat && testSuite?.custom_fields?.length > 0;
    return (
        <div className={cn("overflow-hidden", className)}>
            <div className="">
                {/* Custom fields section */}
                {hasCustomFields && (
                    <div className="px-4 print:px-2 py-2">
                        <CustomFieldContainer item={item} testSuite={testSuite} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExpandableContent;
